var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.loading)?_c('div',{attrs:{"id":"loading"}},[_c('div',{staticClass:"outsideDiv"},[_c('div',{staticClass:"loader"}),_c('div',{staticClass:"insideDiv"},[_vm._v(_vm._s(_vm.$t("components.kLoading.message")))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }